import firebase from "firebase";

export async function getSymposiums() {
  console.log('getSymposiums', getSymposiums);
  var symposiums = []
  var querySnapshot = await firebase.firestore().collection("symposiums").get()
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    symposiums.push({ id: doc.id, ...doc.data() })
  });
  return symposiums
}

export async function getSymposio(id) {
  console.log('getSymposio');
  console.log(id);

  var docRef = await firebase.firestore().collection("symposiums").doc(id);
  var docSnap = await docRef.get()

  if (docSnap.exists) {
    console.log("Document data:", docSnap.data());
    var symposia = { id: docSnap.id, ...docSnap.data() }
    return symposia
  } else {
    // doc.data() will be undefined in this case
    console.log("No such document!");
  }

}

export function createSimposio(data) {
  // Add a new document with a generated id.
  firebase.firestore().collection("symposiums").add(data)
    .then((docRef) => {
      console.log("Document written with ID: ", docRef.id)
    })
    .catch((error) => { console.error("Error adding document: ", error) })
}